// extracted by mini-css-extract-plugin
export default {"main":"Homepage_main__NO2Fq","second_section":"Homepage_second_section__elz+I"};